/**
 * Google Map Loader Helper (legacy compatibility)
 * Uses @googlemaps/js-api-loader v1.16.8
 */
import { loadGoogleMaps, loadGoogleMapsLibrary } from './googleMapsLoader';

export const googleMapLoader = async (name) => {
    try {
        await loadGoogleMaps();
        await loadGoogleMapsLibrary(name);
        return new google.maps.places.AutocompleteService();
    } catch (error) {
        console.error('Google Maps loader error:', error);
    }
}